import { render } from "./NetworkError.vue?vue&type=template&id=ebb24052"
const script = {}
script.render = render

export default script